import React, { useEffect, useRef, useState } from "react";
import { api } from "../api";
import { Box, Typography, Table, TableHead, TableRow, TableCell, TableBody, Button, Avatar, LinearProgress, TextField } from "@mui/material";

const UPLOAD_URL = "https://media.swancreate.com/upload";
const MEDIA_PUBLIC_BASE = "https://media.swancreate.com/images/partner-logos/";

function parseUploadUrl(json) {
  // Prefer the stable GUID permalink (avoids filename collisions between districts).
  if (json && typeof json.permalink === "string") return json.permalink;
  if (json && typeof json.url === "string") return json.url;
  const m = json && typeof json.message === "string" && json.message.match(/'([^']+)'/);
  return m ? `${MEDIA_PUBLIC_BASE}${m[1]}` : null;
}

export default function PartnerLogos() {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("");
  const [busyId, setBusyId] = useState(null);
  const fileRefs = useRef({});

  const load = () =>
    api.get("/accounts?Status=Customer").then((r) =>
      setRows((r.data || [])
        .filter((a) => a.District && ("" + a.District).trim())
        .sort((a, b) => ("" + a.District).localeCompare("" + b.District))));
  useEffect(() => { load(); }, []);

  const onPick = async (acct, file) => {
    if (!file || !file.type.startsWith("image/")) return;
    setBusyId(acct.apiid);
    try {
      const fd = new FormData();
      fd.append("file", file, file.name);
      fd.append("folder", "partner-logos");
      const res = await fetch(UPLOAD_URL, { method: "POST", body: fd });
      const url = parseUploadUrl(await res.json());
      if (!res.ok || !url) throw new Error("Upload failed");
      await api.put(`/accounts/${acct.apiid}`, { logoUrl: url });
      await load();
    } catch (e) {
      console.error(e);
    } finally {
      setBusyId(null);
    }
  };

  const shown = rows.filter((a) => ("" + a.District).toLowerCase().includes(filter.toLowerCase()));

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>Partner Logos</Typography>
      <TextField size="small" label="Filter by district" value={filter}
        onChange={(e) => setFilter(e.target.value)} sx={{ mb: 2 }} />
      {busyId && <LinearProgress sx={{ mb: 1 }} />}
      <Table size="small">
        <TableHead><TableRow>
          <TableCell>Logo</TableCell><TableCell>District</TableCell><TableCell>State</TableCell><TableCell align="right">Action</TableCell>
        </TableRow></TableHead>
        <TableBody>
          {shown.map((a) => (
            <TableRow key={a.apiid}>
              <TableCell>
                <Avatar variant="rounded" src={a.logoUrl || undefined} sx={{ width: 48, height: 48 }}>
                  {("" + (a.District || "?")).charAt(0)}
                </Avatar>
              </TableCell>
              <TableCell>{a.District}</TableCell>
              <TableCell>{a.State}</TableCell>
              <TableCell align="right">
                <input type="file" accept="image/*" hidden
                  ref={(el) => { fileRefs.current[a.apiid] = el; }}
                  onChange={(e) => onPick(a, e.target.files[0])} />
                <Button size="small" variant="outlined" disabled={busyId === a.apiid}
                  onClick={() => fileRefs.current[a.apiid] && fileRefs.current[a.apiid].click()}>
                  {busyId === a.apiid ? "Uploading…" : a.logoUrl ? "Replace" : "Upload"}
                </Button>
              </TableCell>
            </TableRow>
          ))}
          {shown.length === 0 && <TableRow><TableCell colSpan={4}>No partner districts.</TableCell></TableRow>}
        </TableBody>
      </Table>
    </Box>
  );
}
